import { render, staticRenderFns } from "./TopBarItem2.vue?vue&type=template&id=1f7b73e8&scoped=true"
import script from "./TopBarItem2.vue?vue&type=script&lang=js"
export * from "./TopBarItem2.vue?vue&type=script&lang=js"
import style0 from "./TopBarItem2.vue?vue&type=style&index=0&id=1f7b73e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b73e8",
  null
  
)

export default component.exports